import type { FunctionComponent, SuspenseProps } from 'react';
import { Suspense } from 'react';

import { Loader } from '../loader/Loader';

interface SuspendedProps extends SuspenseProps {}

export const Suspended: FunctionComponent<SuspendedProps> = ({ children, ...rest }) => {
  return (
    <Suspense fallback={<Loader />} {...rest}>
      {children}
    </Suspense>
  );
};
